// Admin entry: the whole deployable is AdminApp. Routes keep their /admin base
// (AdminApp hardcodes it), so the admin Pages project ships a _redirects rule
// sending / to /admin.
import AdminApp from "../apps/admin/AdminApp";
import { renderRoot } from "../bootstrap";

renderRoot(<AdminApp />);
